import React, { useState } from 'react';
import styles from '../styles/FAQ.module.css';

const FAQ = ({ faqs }) => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleFAQ = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div className={styles.faqContainer}>
      {faqs.map((faq, index) => (
        <div key={index} className={styles.faqItem}>
          <div 
            className={styles.faqQuestion}
            onClick={() => toggleFAQ(index)}
            role="button"
            tabIndex={0}
            onKeyPress={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                toggleFAQ(index);
              }
            }}
          >
            <span>{faq.question}</span>
            <span className={`${styles.icon} ${expandedIndex === index ? styles.iconExpanded : ''}`}>
              {expandedIndex === index ? '▲' : '▼'}
            </span>
          </div>
          {expandedIndex === index && (
            <div className={styles.faqAnswer}>
              {faq.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FAQ;
